// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3DuGA","rootSuccess":"CompleteLink_rootSuccess__12CsM","rootFailure":"CompleteLink_rootFailure__330rF","isDisabled":"CompleteLink_isDisabled__YEi0v"};